import { fetchWithAuth } from "./FetchHelper";

const apiUrl = process.env.REACT_APP_API_URL;

export async function SaveAulaRaConfig(idAula: string, config: any[]) {
    try {
        const response = await fetchWithAuth(`${apiUrl}:8061/jutge/aules/${idAula}/ra-config`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(config)
        });
        return response && response.ok;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
